import React, { Component } from 'react';
import GeckoFeatures from 'services/gecko-features';
import {
  GeckoModal,
  GECKO_CONSTS,
  GeckoModalService,
  GeckoToastService,
} from 'ui';

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: props.tag,
    };
  }
  fields = [
    {
      label: 'Tag Name',
      key: 'name',
      required: true,
      width: '100%',
    },
    {
      label: 'Colour',
      key: 'colour',
      type: GECKO_CONSTS.FIELD_TYPE_COLOR,
    },
    GeckoFeatures.can('ai-insights') && {
      label: 'Allow AI to use this tag',
      key: 'allow_for_ai',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
      width: '100%',
    },
  ].filter(Boolean);
  footerBtns = [
    {
      preset: 'save',
      handler: () => {
        if (!this.state.values.name) {
          return new GeckoToastService().error('The name field is required');
        }
        new GeckoModalService().close(this.state.values);
      },
    },
  ];
  changeHandler(key, val) {
    const newValues = Object.assign({}, this.state.values, { [key]: val });
    this.setState({ values: newValues });
  }
  render() {
    return (
      <GeckoModal
        id="TagEditModal"
        name={this.props.tag.id ? 'Edit Tag' : 'New Tag'}
        fields={this.fields}
        values={this.state.values}
        handler={this.changeHandler.bind(this)}
        btns={this.footerBtns}
      />
    );
  }
}

export default EditModal;
